import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CircularProgress, Box, Typography } from '@mui/material';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, loading, userRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          background: 'linear-gradient(135deg, #FFF8E1 0%, #FFE4B5 100%)',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#D4AF37', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#D4AF37', fontWeight: 600 }}>
          Verifying Gold Store Access...
        </Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login but save the location they tried to access
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          background: 'linear-gradient(135deg, #FFF8E1 0%, #FFE4B5 100%)',
          p: 3,
        }}
      >
        <Typography variant="h4" sx={{ color: '#D32F2F', mb: 2, fontWeight: 'bold' }}>
          ⚠️ Access Denied
        </Typography>
        <Typography variant="h6" sx={{ color: '#666', mb: 3, textAlign: 'center' }}>
          Your role ({userRole}) does not have permission to access this page.
        </Typography>
        <Typography variant="body1" sx={{ color: '#888', textAlign: 'center', maxWidth: 600 }}>
          Please contact the store owner or manager if you believe this is an error.
        </Typography>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;